import React from 'react';
import BlockedDimeCard from './BlockedDimeCard';
//import robots from '../robots'
import SearchBox from './SearchBox'

const BlockedDimeCardList = ({robots,setTest,onRouteChange }) => {
	return (
		<div>
		{

		robots.map((user, i) =>{
		return (
		<BlockedDimeCard
		onRouteChange = {onRouteChange} 
		setTest={setTest}
		key = {i} 
		dime_id = {robots[i].dime_id} 
		category = {robots[i].category }
		rating = {robots[i].rating}
		image_key = {robots[i].image_key}
		rating_count = {robots[i].rating_count}
		/>
		);
		})
	}
		</div>
	);
}

export default BlockedDimeCardList;